var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"v2-btn",class:[
    ("v2-btn--" + _vm.variant),
    ("v2-btn--" + _vm.size),
    { 'v2-btn--block': _vm.block, 'v2-btn--loading': _vm.loading } ],attrs:{"disabled":_vm.disabled || _vm.loading,"type":_vm.type}},_vm.$listeners),[(_vm.loading)?_c('span',{staticClass:"v2-btn__spinner"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }